import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '='
    },
    template: `
        <form ng-submit="vm.uploadEmployees()" enctype="multipart/form-data">
            <div class="well">
                <div class="heading01">
                    <h1>{{ 'company.Update employee data' | translate }}</h1>
                </div>
                <div ng-if="!vm.success && !vm.form.errors">
                    <div class="form">
                        <form-row error="vm.form.errors.file">
                            <label class="label">{{ 'general.File' | translate }}</label>
                            <div class="items">
                                <input ngf-select="vm.setFile($file)" ng-model="vm.form.file" type="file">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                    <ul class="actions01">
                        <li class="primary"><button type="submit" class="btn main">{{ 'user.Import' | translate }}</button></li>
                    </ul>
                </div>
                <div ng-if="vm.success">
                    <div class="alert nomargin alert-success" ng-bind-html="vm.success"></div>
                    <div class="form">
                        <div class="row">
                            <span class="label">{{ 'user.Employees added' | translate }}:</span>
                            <div class="items">
                                <span class="text">{{ vm.summary.employeesAdded }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <span class="label">{{ 'user.Employees updated' | translate }}:</span>
                            <div class="items">
                                <span class="text">{{ vm.summary.employeesUpdated }}</span>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li class="primary">
                            <a ng-click="vm.reset()" class="btn bordered02">{{ 'user.Upload more' | translate }}</a>
                        </li>
                    </ul>
                </div>
                <div ng-if="vm.form.errors">
                    <div class="alert nomargin alert-danger">
                        {{ 'user.Upload was not successful. See summary below' | translate }}
                    </div>
                    <ul class="items08">
                        <li ng-repeat="error in vm.form.errors">
                            <p class="heading">{{ error.text }}</p>
                            <p>{{ 'use.Affected rows' | translate }}: {{ error.rows.join(', ') }}</p>
                        </li>
                    </ul>
                    <ul class="actions01">
                        <li class="primary">
                            <a ng-click="vm.reset()" class="btn bordered02">{{ 'user.Retry' | translate }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, lodash, Upload, COMPANY_USER_IMPORT_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.Upload = Upload;
        this.COMPANY_USER_IMPORT_TYPE_ENUM = COMPANY_USER_IMPORT_TYPE_ENUM;
    }

    $onInit () {
        this.form = {};
    }

    setFile (file) {
        this.form.file = file;
    }

    uploadEmployees () {
        const url = `${SEED_CORE.ENV.API_URL}company/company/user-import`;
        this.success = false;

        this.Upload
            .upload({ url, data: { file: this.form.file, companyId: this.company.id } })
            .then((response) => {
                this.summary = {
                    employeesAdded: response.data[this.COMPANY_USER_IMPORT_TYPE_ENUM.KEYS.IMPORT_CREATE].length,
                    employeesUpdated: response.data[this.COMPANY_USER_IMPORT_TYPE_ENUM.KEYS.IMPORT_UPDATE].length
                };
                this.success = this.$translate.instant('user.Import was successful. See summary below');
            })
            .catch((response) => {
                const excelErrors = this.lodash.find(response.data, (data) => {
                    return data.field === 'excel';
                });
                this.form.errors = excelErrors.message;
            })
        ;
    }

    reset () {
        this.form = {};
        this.success = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/companies/form/uploadEmployeeData/index.js